module.exports = __webpack_public_path__ + "static/img/bg-tr.09a1d006.webp";